import React from 'react'
import { FiPlus } from 'react-icons/fi'
import { ProfilingItem } from './profilingItem'
import { experiments } from './mock'

export const Profiling = ({user, preview}) => {
    const { profiles }  = {educations: experiments, experiences: experiments}
   
    return (
        <div className="profiling ">
            <ul className="head">
                {!preview && (
                    <li>
                        <div className="title">{user?.name && user.name}Entrepreneur Profiles </div>
                        <div onClick={()=>{
                        }}><FiPlus className="arrow-icon" /></div>
                    </li>
                ) }
            </ul>
            <ul className="list">

                {
                    profiles?.length > 0 && profiles.map((item,i)=>{
                        return   (
                            <ProfilingItem item={item} key={'profile'+i} />
                        )
                    })
                }
            </ul>
        </div>
    )
}
 